interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  color?: 'blue' | 'primary'
}

const sizeClasses = {
  xs: 'h-4 w-4 border-2',
  sm: 'h-6 w-6 border-2', 
  md: 'h-8 w-8 border-4',
  lg: 'h-12 w-12 border-2',
  xl: 'h-32 w-32 border-2'
}

const colorClasses = {
  blue: 'border-blue-600',
  primary: 'border-primary-600'
}

export function LoadingSpinner({ 
  size = 'md', 
  className = '', 
  color = 'blue' 
}: LoadingSpinnerProps) {
  return (
    <div 
      className={`animate-spin rounded-full ${sizeClasses[size]} ${colorClasses[color]} border-t-transparent ${className}`}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  )
}